export default __webpack_public_path__ + "static/media/Cross.99616d4e.svg";